define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/config",
	"csi/def",
	"csi/def/Field",
	"csi/def/Relationship",
	"csi/form/Widget",
	"csi/locale",
	"csi/store/_base",
	"csi/xml",
	"csi/xml/Query",
], function(declare, lang, csi, config, def, Field, Relationship, Widget, locale, csiStore, xml, Query) {

	const THEME_TO_SEASON = "ThemeToSeason",
		THEME_TO_SEASON_ALL_SEASONS = "ThemeToSeason:AllSeasons",
		THEME_TO_SEASON_SINGLE_SEASON = "ThemeToSeason:SingleSeason",
		LINK_TO_STYLE = "PromoteToTheme_LinkToStyle",
		THEMEMASTER_NODE_NAME = "ThemeMaster/Node Name",
		THEMEMASTER_SUBTYPE = "ThemeMaster/Subtype",
		THEME_SEASONS = "ThemeSeasons",
		THEME_SEASON = "ThemeSeason",
		THEME_BOM_TYPE = "ThemeBOMType";

	return declare(Widget, {
		/** Value is set to true on PromoteToTheme to add specific fields */
		isPromoteAction: false,
		/** Style from the new Theme will be created - useful for Promtoe and New Theme from Style actions */
		fromStyle: null,

		/**
		 * C8-10778: If the Theme parent MasterTheme's Subtype is Single Season, make the "ThemeSeasons" field single-select
		 */
		_buildField: function(ctx, field, tr, tdControl) {
			let name = field.getControlName();
			if (name == THEME_SEASONS && this._isSubtypeSingleSeason()) {
				field.m_type = xml.ATTR_REF;
				field.m_typeControl = def.FIELD_FILTERING_SELECT;
			}

			return this.inherited(arguments);
		},

		_getThemeMasterSubtype: function() {
			let node = this.getViewNode();
			if (node && node.$Type == "Theme") {
				var master = this.getCache().getNode(node.__Parent__);
				if (master) {
					return config.getNodeSetting(master, THEME_TO_SEASON);
				}
			}

			var subtypeUrl = this.getFieldValue(THEMEMASTER_SUBTYPE);
			if (xml.isValidURL(subtypeUrl)) {
				return config.getSubtypeSetting(subtypeUrl, THEME_TO_SEASON);
			}

			return null;
		},

		/**
		 * Handles seasons field when in PromoteToTheme action
		 */
		_handlePromoteToThemeAction: function(defView, isAllSeason) {
			let seasonsField = this.defView.getField(THEME_SEASONS);
			let subtypeField = this.getFieldValue(THEMEMASTER_SUBTYPE);

			if (this.isPromoteAction) {
				//Seasons field is always disabled in the PromoteToTheme action
				this.setFieldDisabled(seasonsField, true);

				// If not "All Seasons" and the action is PromoteToTheme and subtype is not empty
				//	set season to style season 
				if (!isAllSeason && subtypeField != csi.EMPTY_URL) {
					this.setFieldValue(THEME_SEASONS, [this.fromStyle.ParentSeason]);
				}
				// Clears the seasons field for PromoteToTheme action if subtype is empty
				if (subtypeField == csi.EMPTY_URL) {
					this.setFieldValue(THEME_SEASONS, []);
				}
			}
		},

		/**
		 * Determine if parent Master is all season on the following order:
		 * 1. On existing Theme, if the parent Master's subtype is AllSeasons
		 * 2. On New Theme form, use the ThemeMaster Subtype field to determine
		 *
		 * @return {boolean}
		 */
		_isAllSeasons: function() {
			return this._getThemeMasterSubtype() == THEME_TO_SEASON_ALL_SEASONS;
		},

		/**
		 * Determine if it is Single Season:
		 * 1. On existing Theme, if the parent Master's subtype is SingleSeason
		 * 2. On New Theme form, use the ThemeMaster Subtype field to determine
		 *
		 * @return {boolean}
		 */
		_isSubtypeSingleSeason: function() {
			return this._getThemeMasterSubtype() == THEME_TO_SEASON_SINGLE_SEASON;
		},

		/**
		 * C8-10778
		 */
		_onChangeThemeMasterSubtype: function(defView, field, value) {
			let seasonsField = this.defView.getField(THEME_SEASONS);
			let bomSubtypeField = this.defView.getField(THEME_BOM_TYPE);

			if (!seasonsField) {
				return;
			}

			this.setFieldDisabled(THEME_BOM_TYPE, false);

			// When ThemeMaster Subtype selected is "Single Season", the Theme.ThemeSeasons field should be single-select
			let isSingleSeason = xml.isValidURL(value) && config.getSubtypeSetting(value, THEME_TO_SEASON) == THEME_TO_SEASON_SINGLE_SEASON;
			let newType = isSingleSeason ? xml.ATTR_REF : xml.ATTR_REFLIST;
			let newTypeControl = isSingleSeason ? def.FIELD_FILTERING_SELECT : def.FIELD_MULTI_SELECT;

			if (newType != seasonsField.m_type) {
				seasonsField.m_type = newType;
				seasonsField.m_typeControl = newTypeControl;

				this._rebuildField(seasonsField);
			}

			// When ThemeMaster Subtype selected is "All Seasons", the Theme.ThemeSeasons field should be disabled
			let isAllSeason = this._isAllSeasons();
			this.setFieldDisabled(seasonsField, isAllSeason);
			if (isAllSeason) {
				this.setFieldValue(THEME_SEASONS, []);
			}
			this._handlePromoteToThemeAction(defView, isAllSeason);

			if (xml.isValidURL(value) && config.getSubtypeSetting(value, "ThemeBOMFeature") === "ThemeBOMFeature:Off") {
				this.setFieldValue(THEME_BOM_TYPE, csi.EMPTY_URL);
				this.setFieldDisabled(THEME_BOM_TYPE, true);
			}
		},

		/**
		 * @override
		 * customize the store
		 */
		getFieldStore(field, value) {
			const name = field.getControlName();

			if (name === THEMEMASTER_SUBTYPE && this.isPromoteAction) {
				return config.getSubtypeStore("ThemeMaster", (subtypeSettings) => subtypeSettings.ThemeBOMFeature === "ThemeBOMFeature:StyleBOM");
			}

			const store = this.inherited(arguments);

			if (name === THEME_SEASONS) {
				// add this entry so that empty entry is there and it'll be working fine if user selects none from "GoToDialog"
				store.put(csiStore.nameObject(""));
			}

			return store;
		},

		/**
		 * @override
		 */
		_resolveView: function() {
			let source = this.getFormData().getSource();
			let action = source.getAction();
			let seasonsField = this.defView.getField(THEME_SEASONS);

			// Seasons field is always disabled for PromoteToTheme action
			if (this.isPromoteAction) {
				this.setFieldDisabled(seasonsField, true);
			}

			// ensure new Theme Node Name is sent through request
			const newThemeNodeNameField = this.getField("Node Name");
			if (newThemeNodeNameField) {
				newThemeNodeNameField.idParameter = "ThemeName";
			}

			// The form to create a Theme from a Material needs a new field added:
			// a drop-down single-select optional field for the user to select a BOM Section Definition.
			if (action.m_id == "NewThemeFromColorMaterials" || action.m_id == "TSGNewThemeFromColorMaterials") {
				let material = source.getNode();

				let q = new Query()
					.Attr("Active", xml.OP_EQUALS, true)
					.Attr("BOMProductType", xml.OP_EQUALS, "ProductType:Style")
					.Attr("PlacementProductType", xml.OP_EQUALS, "ProductType:Material");

				q.Or()
					.RefAttr("PlacementProductTypes", xml.OP_EQUALS, material.ProductType)
					.RefAttr("PlacementProductTypes", xml.OP_NULL);


				this.defView.addField(lang.mixin(new Field(), {
					m_label: locale.type("BOMSectionDefinition"),
					idParameter: "BOMSectionDefinition",
					m_typeControl: def.FIELD_FILTERING_SELECT,
					m_relationship: lang.mixin(new Relationship(), {
						m_typeNode: "BOMSectionDefinition",
						m_query: q
					})
				}));
			}

			// combine master form if New/Edit action
			if (this.isNew() || this.isEdit()) {
				this.combineForm(true, xml.ATTR_PARENT);
			}

			this.inherited(arguments);

			let fieldSubtype = this.defView.getField(THEMEMASTER_SUBTYPE);

			//C8-12862: Insert ThemeMaster.Subtype field if it hasn't been added to the FormDefinition
			if (!fieldSubtype && action.m_id != "Copy") {
				fieldSubtype = this.insertField(lang.mixin(new Field(), {
					m_id: "Subtype",
					m_path: "Child:__Parent__",
					m_bRequired: true,
					idParameter: "Subtype",
					combinedFormType: "ThemeMaster"
				}), 0);

				if (this.isNew() && source.getParent()?.$Type == "ThemeMaster") {
					this.setFieldDisabled(fieldSubtype, true);
					const themeMasterField = this.getField(THEMEMASTER_NODE_NAME);
					if (themeMasterField) {
						this.setFieldDisabled(themeMasterField, true); // theme master
					}
				}
			}

			if (fieldSubtype) {
				fieldSubtype.m_onChange = "_onChangeThemeMasterSubtype";
			}
			if (this.isPromoteAction) {
				const fd = this.getFormData();
				this.fromStyle = fd.getNode() || this.fromStyle;
				fd.setNode(null);

				if (this.fromStyle) {
					this.insertFieldIfNotExist(LINK_TO_STYLE, 0, {
						m_typeControl: def.FIELD_CHECKBOX,
					});

					this.insertFieldIfNotExist(xml.isValidURL(this.fromStyle.Theme) ? "PromoteToTheme_StyleLinkedToTheme" : "PromoteToTheme_EstablishNewLink", 1, {
						m_typeControl: def.FIELD_COMMENT,
					});

					this.getField(THEME_SEASONS).m_bRequired = true;
					this.getField(xml.ATTR_NAME).m_bRequired = false;
					this.getField(THEMEMASTER_SUBTYPE).bForceEditable = true;
					this.getField(THEME_SEASON).bHidden = true;
					this.getField(THEME_BOM_TYPE).bHidden = true;
				}
			}
		}

	});
});